export const RECORDING_STATUS = {
  INPROGRESS: 0,
  COMPLETED: 1,
  ABSENT: 2,
  DELETED: 3
};

export const COMPLETE_TASK_RESULT = {
  SUCCESS: 'Success',
  ALREADY_SUBMITTED: 'AlreadySubmitted',
  RESULT_IS_NOT_VALID: 'ResultIsNotValid'
};

export const ROUTES = {
  LOGIN: '/login',
  LOADING: '/loading',
  INSTRUCTIONS: '/instructions',
  GUIDELINES: '/guidelines',
  HOME: '/',
  JOB: '/job',
  JOB_FEEDBACK: '/job/feedback',
  JOB_CALL: '/job/call',
  JOB_INSTRUCTIONS: '/job/instructions',
  SOW: '/sow',
  NO_MORE_TASKS: '/job/no-more-tasks',
  AGENT_KIT: '/kit',
  VENDOR_PRIVACY_TERMS: '/vendor/privacy-terms'
};

export const TASK_STATUS = {
  Pending: { code: 0, name: 'Pending' },
  Reserved: { code: 1, name: 'Reserved' },
  Assigned: { code: 2, name: 'Assigned' },
  Wrapping: { code: 3, name: 'Wrapping' },
  Completed: { code: 4, name: 'Completed' },
  Canceled: { code: 5, name: 'Canceled' },
  Deleted: { code: 6, name: 'Deleted' }
};

export const CALL_STATUS = {
  INITIATED: { code: 0, name: 'Initiated' },
  RINGING: { code: 1, name: 'Ringing' },
  INPROGRESS: { code: 2, name: 'InProgress' },
  COMPLETED: { code: 3, name: 'Completed' },
  BUSY: { code: 4, name: 'Busy' },
  FAILED: { code: 5, name: 'Failed' },
  NOANSWER: { code: 6, name: 'NoAnswer' },
  CANCELED: { code: 7, name: 'Canceled' }
};

export const FEEDBACK_DETAIL_OPTIONS = {
  CANT_LISTEN_RECORDING: 'CantListenRecording',
  STATUS_CHANGED_WITHOUT_INTERACTION: 'StatusChangedWithoutInteraction',
  CALL_WITH_INTERFERENCE: 'CallWithInterference',
  GLITCH_DURING_EXECUTION: 'GlitchDuringExecution',
  MISMATCH_SCRIPTS: 'MismatchScripts',
  INAPPROPRIATE_SCRIPT: 'InappropriateScript',
  INCOHERENT_SCENARIO: 'IncoherentScenario',
  BAD_ENVIRONMENT: 'BadEnvironment',
  VOICEMAIL: 'Voicemail',
  NOT_READY_TO_EXECUTE: 'NotReadyToExecute',
  NON_NATIVE: 'NonNative',
  OTHER_DISHONEST_CONTRIBUTOR: 'OtherDishonestContributor',
  OTHER_CONTENT_ISSUE: 'OtherContentIssue',
  OTHER_TECHNICAL_ISSUE: 'OtherTechnicalIssue'
};

export const FEEDBACK_OPTIONS = {
  OK: 'Ok',
  DISHONEST_CONTRIBUTOR: 'DishonestContributor',
  CONTENT_ISSUE: 'ContentIssue',
  TECHNICAL_ISSUE: 'TechnicalIssue',
  NONE: 'None'
};

export const ERROR_MESSAGES = {
  ACCESS_DENIED_EXCEPTION: 'ACCESS_DENIED_EXCEPTION',
  INVALID_CREDENTIALS_EXCEPTION: 'INVALID_CREDENTIALS_EXCEPTION',
  EMAIL_INVALID_EXCEPTION: 'EMAIL_INVALID_EXCEPTION',
  USER_STATUS_HAS_CHANGED_EXCEPTION: 'USER_STATUS_HAS_CHANGED_EXCEPTION',
  PROFILE_INCOMPLETE_EXCEPTION: 'PROFILE_INCOMPLETE_EXCEPTION'
};

export const SKIP_GUIDELINES_ON_LOGIN = 'showGuidelinesOnLogin';
export const SKIP_AGENT_KIT_NEXT_LOGIN = 'skipAgentKitNextLogin';
export const NO_CALL_ONGOING = 'NoCallOngoing';
export const NO_CONNECTION_ESTABLISHED = 'NoConnectionEstablished';
export const BROADBAND_CALL_CODE = 'BBDDC';
export const POLLING_DEFAULT_INTERVAL = 10000;
